




















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import SchoolSlide from "../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/SchoolModels/SchoolSlide";
@Component
export default class MainSliderComponent extends Vue {


  slides: SchoolSlide[] = [];
  mounted() {
    this.$api.SchoolService.GetSchoolSlidesEvent.once(
      this.onGetSlides.bind(this)
    );
    this.$api.SchoolService.GetSchoolSlides();
  }

  onGetSlides(res: WsResponseModel<SchoolSlide[]>) {
    if(res.IsSuccess)
      this.slides = res.Value;
  }
}
